import SparkMD5 from 'spark-md5'


// 获取文件的唯一MD5标识码
export function getFileMd5(file) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        const spark = new SparkMD5.ArrayBuffer()
        fileReader.readAsArrayBuffer(file)
        fileReader.onload = e => {
            spark.append(e.target.result)
            let md5 = spark.end()
            resolve(md5)
        }
        fileReader.onerror = () => {
            reject(new Error("文件读取异常"));
        };
    })
}

// const CHUNK_SIZE = 100 * 1024; // 100KB
/**
 * 分片
 * @param file 需要分片的文件
 * @param size 每片大小 单位MB
 * @param md5 文件MD5值
 * @returns {*[]}
 */
export async function sliceFile(file, size, md5) {
    let chunkSize = size * 1024 * 1024;
    let totalChunks = Math.ceil(file.size / chunkSize);
    let chunks = [];
    for (let index = 0; index < totalChunks; index++) {
        let start = index * chunkSize;
        let end = Math.min(start + chunkSize, file.size);
        let chunk = file.slice(start, end);
        let formData = new FormData();

        formData.append("fileName", file.name);
        formData.append("totalSize", file.size);
        formData.append("eachChunkSize", chunkSize);
        formData.append("md5", md5);
        formData.append("currentChunkNumber", index + 1);
        formData.append("currentChunkSize", (end - start));
        formData.append("totalChunks", totalChunks);
        formData.append("file", chunk);
        chunks.push(formData);
    }
    return chunks;
}
